module.exports = __webpack_public_path__ + "static/media/header.0ac26c07.jpg";